import { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { useAuth } from '../contexts/AuthContext';
import { Button } from './ui/button';
import { AlertCircle, Mail, X } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export default function EmailVerificationBanner() {
  const { user } = useAuth();
  const [dismissed, setDismissed] = useState(false);
  const [sending, setSending] = useState(false);

  // Don't show if email is verified, dismissed, or user is from Google OAuth
  if (!user || user.email_verified || dismissed) {
    return null;
  }

  const handleResend = async () => {
    setSending(true);
    try {
      await axios.post(`${API_URL}/auth/resend-verification`);
      toast.success('Verification email sent! Please check your inbox.');
    } catch (error) {
      if (error.response?.status === 429) {
        toast.error('Please wait a few minutes before requesting another email.');
      } else {
        toast.error('Failed to send verification email');
      }
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="bg-amber-500/10 border border-amber-500/30 rounded-lg p-4 mb-6">
      <div className="flex items-start justify-between gap-4">
        <div className="flex items-start gap-3">
          <AlertCircle className="w-5 h-5 text-amber-500 mt-0.5 flex-shrink-0" />
          <div>
            <p className="font-medium text-amber-200">Verify your email address</p>
            <p className="text-sm text-muted-foreground mt-1">
              Please verify your email to unlock all features. Check your inbox for the verification link.
            </p>
          </div>
        </div>
        <div className="flex items-center gap-2 flex-shrink-0">
          <Button 
            variant="outline" 
            size="sm" 
            className="gap-2"
            onClick={handleResend}
            disabled={sending}
          >
            <Mail className="w-4 h-4" />
            {sending ? 'Sending...' : 'Resend'}
          </Button>
          <Button 
            variant="ghost" 
            size="icon"
            className="h-8 w-8"
            onClick={() => setDismissed(true)}
          >
            <X className="w-4 h-4" />
          </Button>
        </div>
      </div>
    </div>
  );
}
